export const hoursFormat = 'HH:mm';
